import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withArraySearchFilter,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMappingConfiguration,
    withDefaultSearchParamsMetadata,
    withFragmentIdProp,
    withFragmentSearchFilter,
    withMetadata,
    withSearchFilter,
} from '@pf/shared-utility';
import {
    EquipmentCreate,
    EquipmentDto,
    EquipmentRead,
    EquipmentSearchParams,
} from '../../entities/equipment.dto';
import {
    CustomFieldMetadataMap,
    NoteMetadataMap,
    ResourceAuthSymbol,
    UserFragmentSymbol,
} from '@pf/shared/util-platform';
import { withWarehouseSearchFilter } from '../wms-mapping.util';
import { ContainerMetadataMap } from '../containers/container.mapping-profile';

const symbols = entitySymbols(PFWmsEntities.Equipment);

withDefaultEntityMetadata<EquipmentDto>(symbols.dto, {
    assignedToUser: UserFragmentSymbol,
    barcode: String,
    description: String,
    lastMaintenanceDate: String,
    name: String,
    notes: [NoteMetadataMap.symbols.dto],
    status: String,
    warehouse: Object,
    resourceAuth: ResourceAuthSymbol,
    customFields: [CustomFieldMetadataMap.symbols.dto],
    equipmentType: Object,
    containers: [ContainerMetadataMap.symbols.dto],
    zone: Object,
});

withDefaultEntityMetadata<EquipmentRead>(symbols.entity, {
    assignedToUser: UserFragmentSymbol,
    barcode: String,
    description: String,
    lastMaintenanceDate: String,
    name: String,
    notes: [NoteMetadataMap.symbols.entity],
    status: String,
    warehouse: Object,
    resourceAuth: ResourceAuthSymbol,
    customFields: [CustomFieldMetadataMap.symbols.entity],
    equipmentType: Object,
    containers: [ContainerMetadataMap.symbols.entity],
    zone: Object,
});

withMetadata<EquipmentCreate>(symbols.createBody, {
    assignedToUserId: String,
    barcode: String,
    description: String,
    lastMaintenanceDate: String,
    name: String,
    notes: [NoteMetadataMap.symbols.createBody],
    status: String,
    warehouseId: String,
    resourceAuth: ResourceAuthSymbol,
    equipmentTypeId: String,
    zoneId: String,
});

withDefaultSearchParamsMetadata<EquipmentSearchParams>(symbols.searchParams, {
    warehouseId: String,
    equipmentTypeId: String,
    status: [String],
    barcode: String,
    name: String,
    zoneId: String,
});

export const EquipmentMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<EquipmentRead, EquipmentDto>(
            mapper,
            symbols.entity,
            symbols.dto
        );
        createMap<EquipmentDto, EquipmentRead>(
            mapper,
            symbols.dto,
            symbols.entity
        );
        createMap<EquipmentDto, EquipmentCreate>(
            mapper,
            symbols.dto,
            symbols.createBody,
            withFragmentIdProp('assignedToUser'),
            withFragmentIdProp('warehouse'),
            withFragmentIdProp('equipmentType'),
            withFragmentIdProp('zone')
        );
        createMap<IQueryParams<EquipmentDto>, EquipmentSearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            withSearchFilter('name'),
            withSearchFilter('barcode'),
            withFragmentSearchFilter('zone'),
            withArraySearchFilter('status'),
            withFragmentSearchFilter('equipmentType'),
            withWarehouseSearchFilter(),
            ...withDefaultSearchParamsMappingConfiguration()
        );
    },
};
